import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
    // 模块引入
import format from "./modules/formatTemplate"
import task from "./modules/taskTemplate"
import strategy from "./modules/strategyTemplate"
import Comprehensive from "./modules/Comprehensive"
export default new Vuex.Store({
    state: {},
    mutations: {},
    actions: {},
    modules: { format, task, strategy, Comprehensive }
})